import { render, staticRenderFns } from "./TabDocuments.vue?vue&type=template&id=9f6d3740&scoped=true&"
import script from "./TabDocuments.vue?vue&type=script&lang=js&"
export * from "./TabDocuments.vue?vue&type=script&lang=js&"
import style0 from "./TabDocuments.vue?vue&type=style&index=0&id=9f6d3740&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f6d3740",
  null
  
)

export default component.exports